import React from "react";

// Styles
import styles from "./StudentTutorial/StudentTutorial.module.css";

// MUI
import CloseIcon from "@mui/icons-material/Close";

// redux
import { setDemo } from "../store/demo.actions";
import { useDispatch, useSelector } from "react-redux";

export default function StudentDemo() {
  const dispatch = useDispatch();
  const showDemo = useSelector((state) => state.demo?.demo);

  //  video links to show with dummy data
  // const links = {
  //   interactive:
  //     window.innerWidth <= 480
  //       ? "https://youtube.com/shorts/VI-frTxpuF8?si=-14FqWAx4M-Tmxx8"
  //       : "https://app.supademo.com/embed/cm9i895gw26imljv50ye33nrf?embed_v=2",

  //   video:
  //     window.innerWidth <= 480
  //       ? "https://youtube.com/shorts/VI-frTxpuF8?si=-14FqWAx4M-Tmxx8"
  //       : "https://www.youtube.com/embed/FmblrbYR3iA?si=Fvhm0eob7W0I-o4V&autoplay=1&mute=1&loop=1",
  // };

  const links = {
    interactive:
      window.innerWidth <= 480
        ? "https://www.youtube.com/embed/VI-frTxpuF8"
        : "https://app.supademo.com/embed/cm9i895gw26imljv50ye33nrf?embed_v=2",

    video:
      window.innerWidth <= 480
        ? "https://www.youtube.com/embed/VI-frTxpuF8"
        : "https://www.youtube.com/embed/FmblrbYR3iA?autoplay=1&mute=1&loop=1",
  };


  // Functions - to set the demo object in redux store
  const handleClose = () => {
    dispatch(setDemo(false));
  };

  return (
    <div className={styles.demo_container}>
      <CloseIcon className={styles.demo_close} onClick={handleClose} />
      <iframe
        src={links[showDemo.link]}
        loading="lazy"
        title="Easetolearn Demo"
        allow="clipboard-write"
        frameborder="0"
        webkitallowfullscreen="true"
        mozallowfullscreen="true"
        allowfullscreen
        className={styles.demo_iframe}
      ></iframe>
    </div>
  );
}
